import createAppStore from './create-app-store';
import createDefaultState from './create-default-state';

const store = createAppStore(
    createDefaultState()
);

export default store;
